/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Chart_Ongoingsofar2Inputs */

const en_us2_stats_chart_ongoingsofar2 = /** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress (so far)`)
};

const es_es2_stats_chart_ongoingsofar2 = /** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En curso (hasta hoy)`)
};

const ru_stats_chart_ongoingsofar2 = /** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В разработке (уже давно)`)
};

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const id_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const ms_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const da_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const de_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const es_mx2_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const fil_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const fr_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const it_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const hu_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const nl_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const no_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const pl_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const pt_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const pt_br2_stats_chart_ongoingsofar2 = pt_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const ro_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const fi_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const sv_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const vi_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const tr_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const cs_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const bg_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const uk_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const ar_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const hi_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const th_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const ja_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const zh_cn2_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const zh_hant1_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/** @type {(inputs: Stats_Chart_Ongoingsofar2Inputs) => LocalizedString} */
const ko_stats_chart_ongoingsofar2 = en_us2_stats_chart_ongoingsofar2;

/**
* | output |
* | --- |
* | "In progress (so far)" |
*
* @param {Stats_Chart_Ongoingsofar2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_chart_ongoingsofar2 = /** @type {((inputs?: Stats_Chart_Ongoingsofar2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Chart_Ongoingsofar2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_chart_ongoingsofar2(inputs)
	if (locale === "ms") return ms_stats_chart_ongoingsofar2(inputs)
	if (locale === "da") return da_stats_chart_ongoingsofar2(inputs)
	if (locale === "de") return de_stats_chart_ongoingsofar2(inputs)
	if (locale === "en-US") return en_us2_stats_chart_ongoingsofar2(inputs)
	if (locale === "es-ES") return es_es2_stats_chart_ongoingsofar2(inputs)
	if (locale === "es-MX") return es_mx2_stats_chart_ongoingsofar2(inputs)
	if (locale === "fil") return fil_stats_chart_ongoingsofar2(inputs)
	if (locale === "fr") return fr_stats_chart_ongoingsofar2(inputs)
	if (locale === "it") return it_stats_chart_ongoingsofar2(inputs)
	if (locale === "hu") return hu_stats_chart_ongoingsofar2(inputs)
	if (locale === "nl") return nl_stats_chart_ongoingsofar2(inputs)
	if (locale === "no") return no_stats_chart_ongoingsofar2(inputs)
	if (locale === "pl") return pl_stats_chart_ongoingsofar2(inputs)
	if (locale === "pt-BR") return pt_br2_stats_chart_ongoingsofar2(inputs)
	if (locale === "pt") return pt_stats_chart_ongoingsofar2(inputs)
	if (locale === "ro") return ro_stats_chart_ongoingsofar2(inputs)
	if (locale === "fi") return fi_stats_chart_ongoingsofar2(inputs)
	if (locale === "sv") return sv_stats_chart_ongoingsofar2(inputs)
	if (locale === "vi") return vi_stats_chart_ongoingsofar2(inputs)
	if (locale === "tr") return tr_stats_chart_ongoingsofar2(inputs)
	if (locale === "cs") return cs_stats_chart_ongoingsofar2(inputs)
	if (locale === "bg") return bg_stats_chart_ongoingsofar2(inputs)
	if (locale === "ru") return ru_stats_chart_ongoingsofar2(inputs)
	if (locale === "uk") return uk_stats_chart_ongoingsofar2(inputs)
	if (locale === "ar") return ar_stats_chart_ongoingsofar2(inputs)
	if (locale === "hi") return hi_stats_chart_ongoingsofar2(inputs)
	if (locale === "th") return th_stats_chart_ongoingsofar2(inputs)
	if (locale === "ja") return ja_stats_chart_ongoingsofar2(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_chart_ongoingsofar2(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_chart_ongoingsofar2(inputs)
	return ko_stats_chart_ongoingsofar2(inputs)
});
export { stats_chart_ongoingsofar2 as "stats.chart.ongoingSoFar" }